// frontend/src/hooks/useToast.js

import { useState } from 'react';

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = 'success', options = {}) => {
    const {
      duration = 3000,
      requireConfirm = false,
      onConfirm = null
    } = options;

    const id = Date.now() + Math.random();
    const toast = { 
      id, 
      message, 
      type, 
      duration,
      requireConfirm,
      onConfirm
    };
    
    setToasts(prev => [...prev, toast]);

    // Only auto-remove if not requiring confirmation
    if (!requireConfirm && duration > 0) {
      setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
      }, duration);
    }
  };

  const removeToast = (id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
  };

  return {
    toasts,
    removeToast,
    showToast,
    
    // Auto-dismiss versions (existing)
    toast_success: (message, duration = 3000) => 
      showToast(message, 'success', { duration }),
    toast_error: (message, duration = 3000) => 
      showToast(message, 'error', { duration }),
    toast_warning: (message, duration = 3000) => 
      showToast(message, 'warning', { duration }),
    toast_info: (message, duration = 3000) => 
      showToast(message, 'info', { duration }),
    
    // Confirm versions (requires OK click)
    toast_success_confirm: (message, onConfirm) => 
      showToast(message, 'success', { requireConfirm: true, onConfirm }),
    toast_error_confirm: (message, onConfirm) => 
      showToast(message, 'error', { requireConfirm: true, onConfirm }),
    toast_warning_confirm: (message, onConfirm) => 
      showToast(message, 'warning', { requireConfirm: true, onConfirm }),
    toast_info_confirm: (message, onConfirm) => 
      showToast(message, 'info', { requireConfirm: true, onConfirm }),
  };
};